import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ausgabenApi } from '../api';

const KATEGORIEN = ['Hardware (PC, Monitore...)', 'Software / Lizenzen', 'Bücher / Fachliteratur', 'Büromaterial', 'Sonstiges'];
const KATEGORIE_ICONS = {
  'Hardware (PC, Monitore...)': '🖥️',
  'Software / Lizenzen': '💿',
  'Bücher / Fachliteratur': '📚',
  'Büromaterial': '🖊️',
  'Sonstiges': '📦'
};

export default function AusgabenPage() {
  const navigate = useNavigate();
  const [ausgaben, setAusgaben] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterJahr, setFilterJahr] = useState('');
  const [filterKategorie, setFilterKategorie] = useState('');
  const [filterSteuer, setFilterSteuer] = useState('');
  const [search, setSearch] = useState('');

  const aktuellesJahr = new Date().getFullYear();
  const jahre = Array.from({ length: 6 }, (_, i) => aktuellesJahr - i);

  useEffect(() => { laden(); }, [filterJahr, filterKategorie, filterSteuer]);

  async function laden() {
    setLoading(true);
    try {
      const params = {};
      if (filterJahr) params.jahr = filterJahr;
      if (filterKategorie) params.kategorie = filterKategorie;
      if (filterSteuer !== '') params.steuerrelevant = filterSteuer;
      const res = await ausgabenApi.list(params);
      setAusgaben(res.data);
    } catch (e) { console.error(e); }
    setLoading(false);
  }

  async function loeschen(id) {
    if (!window.confirm('Ausgabe wirklich löschen?')) return;
    await ausgabenApi.delete(id);
    laden();
  }

  function exportCSV() {
    const params = {};
    if (filterJahr) params.jahr = filterJahr;
    if (filterSteuer !== '') params.steuerrelevant = filterSteuer;
    window.open(ausgabenApi.exportUrl(params));
  }

  const gefiltert = ausgaben.filter(a =>
    !search || a.bezeichnung.toLowerCase().includes(search.toLowerCase())
  );
  const gesamtBetrag = gefiltert.reduce((s, a) => s + a.betrag, 0);

  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 700, color: '#f1f5f9' }}>💰 Ausgaben & Inventar</h2>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button onClick={exportCSV} style={{ padding: '10px 20px', background: '#10b981', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>
            📥 CSV Export
          </button>
          <button onClick={() => navigate('/ausgaben/auswertung')} style={{ padding: '10px 20px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>
            📊 Auswertung
          </button>
          <button onClick={() => navigate('/ausgaben/neu')} className="btn-primary">
            + Neue Ausgabe
          </button>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '12px', marginBottom: '20px', flexWrap: 'wrap' }}>
        <input placeholder="🔍 Suche..." value={search} onChange={e => setSearch(e.target.value)}
          style={{ padding: '8px 14px', borderRadius: '8px', border: '1px solid #334155', flex: '1', minWidth: '150px', background: '#1e293b', color: '#f1f5f9' }} />
        <select value={filterJahr} onChange={e => setFilterJahr(e.target.value)}
          style={{ padding: '8px 14px', borderRadius: '8px', border: '1px solid #334155', background: '#1e293b', color: '#94a3b8' }}>
          <option value="">Alle Jahre</option>
          {jahre.map(j => <option key={j} value={j}>{j}</option>)}
        </select>
        <select value={filterKategorie} onChange={e => setFilterKategorie(e.target.value)}
          style={{ padding: '8px 14px', borderRadius: '8px', border: '1px solid #334155', background: '#1e293b', color: '#94a3b8' }}>
          <option value="">Alle Kategorien</option>
          {KATEGORIEN.map(k => <option key={k} value={k}>{k}</option>)}
        </select>
        <select value={filterSteuer} onChange={e => setFilterSteuer(e.target.value)}
          style={{ padding: '8px 14px', borderRadius: '8px', border: '1px solid #334155', background: '#1e293b', color: '#94a3b8' }}>
          <option value="">Alle</option>
          <option value="1">✅ Steuerrelevant</option>
          <option value="0">❌ Nicht steuerrelevant</option>
        </select>
      </div>

      <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: '12px', padding: '16px 20px', marginBottom: '20px', display: 'flex', justifyContent: 'space-between' }}>
        <span style={{ color: '#64748b' }}>{gefiltert.length} Ausgaben</span>
        <span style={{ fontWeight: '700', fontSize: '18px', color: '#f1f5f9' }}>
          Gesamt: {gesamtBetrag.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}
        </span>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>Lade...</div>
      ) : gefiltert.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>💸</div>
          <div>Keine Ausgaben gefunden</div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {gefiltert.map(a => (
            <div key={a.id} style={{ background: '#1e293b', borderRadius: '12px', padding: '16px 20px', border: '1px solid #334155', display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{ fontSize: '32px' }}>{KATEGORIE_ICONS[a.kategorie] || '📦'}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: '600', fontSize: '16px', marginBottom: '4px', color: '#f1f5f9' }}>{a.bezeichnung}</div>
                <div style={{ color: '#64748b', fontSize: '14px', display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                  <span>{a.kategorie}</span>
                  <span>📅 {new Date(a.kaufdatum).toLocaleDateString('de-DE')}</span>
                  <span>📆 {a.steuerjahr}</span>
                  {a.steuerrelevant
                    ? <span style={{ color: '#10b981', fontWeight: '600' }}>✅ Steuerrelevant</span>
                    : <span style={{ color: '#94a3b8' }}>❌ Nicht steuerrelevant</span>}
                  {a.beleg_dateiname && <span>📎 Beleg vorhanden</span>}
                </div>
              </div>
              <div style={{ fontWeight: '700', fontSize: '18px', color: '#f1f5f9', minWidth: '100px', textAlign: 'right' }}>
                {a.betrag.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button onClick={() => navigate('/ausgaben/' + a.id + '/bearbeiten')} className="btn-secondary">✏️</button>
                <button onClick={() => loeschen(a.id)} className="btn-danger">🗑️</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
